// Global Add-Job modal — used by the Dashboard "+ New Job" button, the
// Dashboard empty-state link, and the Jobs screen toolbar.

import { useState } from 'react';
import { useApp } from '@/context/AppContext';

export default function AddJobModal() {
  const { addJob, customers, closeModal } = useApp();
  const [form, setForm] = useState({
    jobNumber:   `J-${new Date().getFullYear()}-${String(Date.now()).slice(-3)}`,
    customerId:  '',
    projectName: '',
    poNumber:    '',
    dueDate:     '',
    estTons:     '',
    status:      'active',
    notes:       '',
  });
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.jobNumber.trim() || !form.projectName.trim()) return;
    addJob({
      ...form,
      customerId: form.customerId ? Number(form.customerId) : null,
      estTons:    parseFloat(form.estTons) || null,
    });
    closeModal();
  };

  return (
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-head">
        <span className="modal-title">New Job</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">
          <div className="form-row">
            <div className="field">
              <label>Job Number *</label>
              <input value={form.jobNumber} onChange={e => set('jobNumber', e.target.value)} required />
            </div>
            <div className="field">
              <label>Status</label>
              <select value={form.status} onChange={e => set('status', e.target.value)}>
                <option value="quote">Quote</option>
                <option value="active">Active</option>
                <option value="on_hold">On Hold</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Project Name *</label>
            <input
              value={form.projectName}
              onChange={e => set('projectName', e.target.value)}
              placeholder="e.g. Warehouse Structural Steel Package"
              required
            />
          </div>
          <div className="form-row">
            <div className="field">
              <label>Customer / GC</label>
              <select value={form.customerId} onChange={e => set('customerId', e.target.value)}>
                <option value="">Select customer…</option>
                {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div className="field">
              <label>PO Number</label>
              <input value={form.poNumber} onChange={e => set('poNumber', e.target.value)} placeholder="e.g. GC-2026-0042" />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>Due Date</label>
              <input type="date" value={form.dueDate} onChange={e => set('dueDate', e.target.value)} />
            </div>
            <div className="field">
              <label>Estimated Tons</label>
              <input type="number" step="0.1" min="0" value={form.estTons} onChange={e => set('estTons', e.target.value)} placeholder="e.g. 12.5" />
            </div>
          </div>
          <div className="field">
            <label>Notes</label>
            <textarea value={form.notes} onChange={e => set('notes', e.target.value)} placeholder="Scope, special requirements…" />
          </div>
        </div>
        <div className="modal-foot">
          <button type="button" className="btn btn-ghost" onClick={closeModal}>Cancel</button>
          <button type="submit" className="btn btn-primary">Create Job</button>
        </div>
      </form>
    </div>
  );
}
